export default __webpack_public_path__ + "img/well-setup.fdabb6f1.png";